import React, { useEffect, useState } from "react";
import { ModalBase } from "./ModalBase";
import alertTypeEnum from "../../util/alertTypeEnum";
import modalSize from "../../util/modalSizeEnum";
import { Grid2 as Grid, Typography } from "@mui/material";
import { TransferReceiveVariance } from "../../common/Transfer";
import { useStyles } from "./Modal.styles";

type ModalTransferReceiveVariancesFinaliseProps = {
	isOpen: boolean;
	variances: {
		overReceivedItems: TransferReceiveVariance[];
		underReceivedItems: TransferReceiveVariance[];
	};
	setReceiveFinaliseModalIsOpen: (isOpen: boolean) => void;
	setPendingReceive: (isPendingReceive: boolean) => void;
	onCancelFinalise: () => void;
};

export const ModalTransferReceiveVariancesFinalise = ({
	isOpen,
	variances,
	setReceiveFinaliseModalIsOpen,
	setPendingReceive,
	onCancelFinalise,
}: ModalTransferReceiveVariancesFinaliseProps) => {
	const [modalTitle, setModalTitle] = useState("");
	const [modalMessage, setModalMessage] = useState<Array<string>>([]);
	const { overReceivedItems, underReceivedItems } = variances;
	const [varianceReconciliationMessage, setVarianceReconciliationMessages] = useState<string[]>([]);
	const classes = useStyles();
	useEffect(() => {
		setModalTitle("Finalise receive with variances?");
		setModalMessage(["Finalising with variances will adjust stock by processing the following transfer(s):"]);
		const messages: string[] = [];

		if (underReceivedItems.length > 0) {
			setModalMessage([
				"If you're expecting more stock to arrive for this transfer, submit as pending.",
				"Otherwise, finalising with variances will adjust stock by processing the following transfer(s):",
			]);
			underReceivedItems.forEach((item) => {
				messages.push(
					`${item.qty} x ${item.sku} will be returned to ${item.fromLocation.locationName} (${item.fromLocation.locationId})`
				);
			});
		}

		if (overReceivedItems.length > 0) {
			overReceivedItems.forEach((item) => {
				messages.push(
					`${item.qty} x ${item.sku} will be added to ${item.toLocation.locationName} (${item.toLocation.locationId})`
				);
			});
		}

		setVarianceReconciliationMessages(messages);
	}, [overReceivedItems, overReceivedItems.length, underReceivedItems, underReceivedItems.length]);

	const onClickSubmit = async () => {
		onCancelFinalise();
		setPendingReceive(true);
		setReceiveFinaliseModalIsOpen(true);
	};
	const onClickFinalise = async () => {
		onCancelFinalise();
		setPendingReceive(false);
		setReceiveFinaliseModalIsOpen(true);
	};

	return (
		<ModalBase
			title={modalTitle}
			alertType={alertTypeEnum.WARNING}
			primaryButtonName={(underReceivedItems.length > 0 || overReceivedItems.length > 0) ? "Submit as Pending" : "Continue"}
			primaryOutlinedButtonName={(underReceivedItems.length > 0 || overReceivedItems.length > 0) ? "Finalise with Variances" : ""}
			secondaryButtonName="Go back"
			onPrimaryButtonClick={onClickSubmit}
			onPrimaryOutlinedButtonClick={onClickFinalise}
			onSecondaryButtonClick={onCancelFinalise}
			onClose={onCancelFinalise}
			isOpen={isOpen}
			size={modalSize.FULLSCREEN}
			children={
				<>
					<Grid size="grow">
						{modalMessage.map((message, index) => (
							<Typography key={index} variant="body1">
								{message}
							</Typography>
						))}
					</Grid>
					<Grid size="grow" className={classes.messageList}>
						{varianceReconciliationMessage.map((message, index) => (
							<Typography key={index} variant="body2">
								{message}
							</Typography>
						))}
					</Grid>
				</>
			}
		/>
	);
};
